"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextRight = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var TextRight = function TextRight() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666667 0H23.3333C23.7015 0 24 0.298477 24 0.666667V2C24 2.36819 23.7015 2.66667 23.3333 2.66667H0.666667C0.298477 2.66667 0 2.36819 0 2V0.666667C0 0.298477 0.298477 0 0.666667 0ZM11.3333 8H23.3333C23.7015 8 24 7.70152 24 7.33333V6C24 5.63181 23.7015 5.33333 23.3333 5.33333H11.3333C10.9651 5.33333 10.6667 5.63181 10.6667 6V7.33333C10.6667 7.70152 10.9651 8 11.3333 8ZM24 11.3333V12.6667C24 13.0349 23.7015 13.3333 23.3333 13.3333H0.666667C0.298477 13.3333 0 13.0349 0 12.6667V11.3333C0 10.9651 0.298477 10.6667 0.666667 10.6667H23.3333C23.7015 10.6667 24 10.9651 24 11.3333ZM23.3333 21.3333H0.666667C0.298477 21.3333 0 21.6318 0 22V23.3333C0 23.7015 0.298477 24 0.666667 24H23.3333C23.7015 24 24 23.7015 24 23.3333V22C24 21.6318 23.7015 21.3333 23.3333 21.3333ZM23.3333 18.6667H11.3333C10.9651 18.6667 10.6667 18.3682 10.6667 18V16.6667C10.6667 16.2985 10.9651 16 11.3333 16H23.3333C23.7015 16 24 16.2985 24 16.6667V18C24 18.3682 23.7015 18.6667 23.3333 18.6667Z"
  }));
};

exports.TextRight = TextRight;